/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type DeleteAdvancedPatientHistoryEntryMutationVariables = Types.Exact<{
  entryID: Types.Scalars['ID']['input']
}>

export type DeleteAdvancedPatientHistoryEntryMutation = {
  __typename?: 'Mutation'
  deletePatientHistory?:
    | { __typename?: 'CommonPatientHistory'; entryID: string }
    | { __typename?: 'FinancialEligibilityPatientHistory'; entryID: string }
    | { __typename?: 'LabOrderPatientHistory'; entryID: string }
    | { __typename?: 'VideoCallPatientHistory'; entryID: string }
    | null
}

export const DeleteAdvancedPatientHistoryEntryDocument = gql`
  mutation deleteAdvancedPatientHistoryEntry($entryID: ID!) {
    deletePatientHistory(entryID: $entryID) {
      entryID
    }
  }
`
export type DeleteAdvancedPatientHistoryEntryMutationFn = Apollo.MutationFunction<
  DeleteAdvancedPatientHistoryEntryMutation,
  DeleteAdvancedPatientHistoryEntryMutationVariables
>

/**
 * __useDeleteAdvancedPatientHistoryEntryMutation__
 *
 * To run a mutation, you first call `useDeleteAdvancedPatientHistoryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdvancedPatientHistoryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdvancedPatientHistoryEntryMutation, { data, loading, error }] = useDeleteAdvancedPatientHistoryEntryMutation({
 *   variables: {
 *      entryID: // value for 'entryID'
 *   },
 * });
 */
export function useDeleteAdvancedPatientHistoryEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAdvancedPatientHistoryEntryMutation,
    DeleteAdvancedPatientHistoryEntryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteAdvancedPatientHistoryEntryMutation,
    DeleteAdvancedPatientHistoryEntryMutationVariables
  >(DeleteAdvancedPatientHistoryEntryDocument, options)
}
export type DeleteAdvancedPatientHistoryEntryMutationHookResult = ReturnType<
  typeof useDeleteAdvancedPatientHistoryEntryMutation
>
export type DeleteAdvancedPatientHistoryEntryMutationResult =
  Apollo.MutationResult<DeleteAdvancedPatientHistoryEntryMutation>
export type DeleteAdvancedPatientHistoryEntryMutationOptions = Apollo.BaseMutationOptions<
  DeleteAdvancedPatientHistoryEntryMutation,
  DeleteAdvancedPatientHistoryEntryMutationVariables
>
